import { firstValueFrom } from 'rxjs'
import { requestTokenIfExpired } from '@obeta/utils/lib/requestTokenIfExpired'
import { type AppActions } from '@obeta/models/lib/models/BusinessLayer/AppActions'

export const getAuthorizationHeader = async (appActions: AppActions) => {
  const tokens = await firstValueFrom(appActions.tokens$)

  let accessToken = tokens?.accessToken

  if (accessToken) {
    const updatedTokens = await requestTokenIfExpired(appActions, tokens)

    if (updatedTokens?.accessToken) {
      accessToken = updatedTokens?.accessToken
    }
  }

  return accessToken ? { authorization: `Bearer ${accessToken}` } : {}
}

export default getAuthorizationHeader
